import * as Sentry from "@sentry/react";
import { isAxiosError } from "axios";
import { ApiError } from "./client/core/ApiError";
import { DEVELOPERS } from "./client-features";

export const isCurrentUserDeveloper = () => {
  const email = Sentry.getIsolationScope().getUser()?.email;
  return email !== undefined && DEVELOPERS.includes(email);
};

const UUID_PATTERN =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

/** Tags and context identifying the backend request behind `err`, if any. */
export const augmentRequestError = (scope: Sentry.Scope, err: unknown) => {
  if (err instanceof ApiError) {
    scope.setTags({
      api_url: err.request.url,
      api_method: err.request.method,
      status_code: err.status,
    });
    scope.setExtra("error_body", err.body);
    scope.setExtra("query", err.request.query);
    err.name += ": " + err.request.url + " - " + err.statusText;
  } else if (isAxiosError(err) && err.response === undefined) {
    // No response means the request never completed (offline, sleeping tab,
    // CORS, server down). These share a cause, so group them as one issue and
    // keep the endpoint as a tag rather than splitting an issue per query.
    const url = err.config?.url;
    scope.setTags({
      api_url: url
        ? new URL(url, window.location.origin).pathname.replace(
            UUID_PATTERN,
            "{id}"
          )
        : "unknown",
      api_method: err.config?.method?.toUpperCase() ?? "unknown",
      axios_code: err.code ?? "unknown",
    });
    scope.setFingerprint(["axios-no-response", err.code ?? "unknown"]);
  }
};
